/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMergeColumns = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M11 2v5H9V4H4v16h5v-3h2v5H2V2zm11 0v20h-9v-5h2v3h5V4h-5v3h-2V2zm-9 7v2h2v2h-2v2h-2v-2H9v-2h2V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMergeColumns as MergeColumns };
